module.exports = __webpack_public_path__ + "static/media/Gotham-XLight.034f768d.ttf";